var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinesviclogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 814.1 260.4",
    style: {
      enableBackground: "new 0 0 814.1 260.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.7,65.7v13.8h30.9v14.1h-30.9v23.5h-16.2V51.4h51v14.2H185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.6,117.2h-16.2V51.4h16.2V117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319,51.4v65.7h-13.4l-33.4-38.1v38.1H256V51.4h13.5l33.4,39.2V51.4H319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.9,103.2v13.9h-51.4V51.4h51.1v13.9h-34.9v12.4h32v13.1h-32v12.4H381.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.9,102.5l16.2-5.8c2,5.9,6.5,8.4,12.6,8.4c6.1,0,9.7-2.7,9.7-6.8c0-2.9-1.4-4.8-6.1-5.8l-13.2-2.9 c-9.5-2.1-17.7-7.1-17.7-19c0-12.8,10.7-20.7,26.2-20.7c12.4,0,21.9,5.2,25.8,14.4l-15.4,5C427,65,422.7,63,418.5,63 c-5.4,0-8.9,2.9-8.9,6.7c0,2.6,1.1,4.6,5.2,5.5l13.1,3c11.4,2.6,18.1,8.7,18.1,19.1c0,14-12.5,21.3-27.2,21.3 C405.6,118.6,394.3,112.9,390.9,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.2,169.4h0.9l5.3,14.3h-11.6L611.2,169.4z M607.8,139.6L577,206h19.7l3.4-7.6h23.1l3.4,7.6h19.7 l-30.9-66.4H607.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.2,138.1c-19.8,0-37,15-37,34.7c0,19.7,17.1,34.7,37,34.7c19.8,0,37-15,37-34.7 C477.2,153,460.1,138.1,440.2,138.1 M440.2,190.3c-9.7,0-17.6-7.9-17.6-17.5c0-9.6,7.9-17.5,17.6-17.5c9.7,0,17.6,7.9,17.6,17.5 C457.8,182.4,449.9,190.3,440.2,190.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.1,163.7c0-13.9-11.1-24.2-25.1-24.2h-30.3V206h18.1v-18.1h8.5l8.3,18.1h20.3l-11.3-22.3 C536,179.2,541.1,172.7,541.1,163.7 M515.3,171.6h-11.6v-15.8h11.6c4.1,0,6.8,4.6,6.8,7.9C522.1,167,519.4,171.6,515.3,171.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550,206h18.1v-66.4H550V206z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.8,206h18.1v-66.4h-18.1V206z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.5,139.6 189.6,139.6 206.5,175.8 223.4,139.6 243.6,139.6 213.2,206 201,206  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "345.7,140.4 345.7,156.2 363.8,156.2 363.9,206.3 382,206.3 382,156.2 400.3,156.2 400.3,139.9  345.7,139.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.9,189.1c-5.2,11.7-16.7,18.4-30.9,18.4c-19.7,0-35.3-15.2-35.3-34.7c0-19.4,15.6-34.7,35.3-34.7 c12.5,0,23.7,5.8,29.5,15.6l-14.7,7.2c-3.3-5.3-8.5-7.8-14.9-7.8c-10.5,0-18.9,8.4-18.9,19.7s8.4,19.8,18.9,19.8 c6.8,0,12.5-3.1,15.6-9.5L341.9,189.1z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.7,256.3 6.2,256.3 126.9,0.9 144.5,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "688.9,256.3 671.4,256.3 792.1,0.9 809.6,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.1,202.8 0.9,202.8 78,39.5 89.3,39.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinesviclogo);
export default __webpack_public_path__ + "static/media/finesviclogo.c90beec6.svg";
export { ForwardRef as ReactComponent };